import { FUNCTION_KEYS } from '@/constants';
import { type AccessScope } from '@/routers-capability/routeMeta';
import { FunctionKey } from '@/types';

export type AvailableFunctionKeysResult =
  | { kind: 'keys'; keys: FunctionKey[] }
  | { kind: 'error' };

/**
 * 画面遷移時とメニュー表示時で共通のアクセス可否。
 * `pending` は判定に必要な権限情報がまだ無いことを表す。権限情報の取得は呼び出し側が行う。
 */
export type AccessDecision = 'allow' | 'deny' | 'pending' | 'error';

export const parseAvailableFunctionKeys = (
  value: unknown,
): AvailableFunctionKeysResult => {
  if (!Array.isArray(value)) return { kind: 'error' };
  if (!value.every(v => typeof v === 'string')) return { kind: 'error' };

  const keys = FUNCTION_KEYS.filter(key => value.includes(key));
  return { kind: 'keys', keys };
};

export const evaluateAccess = (
  scope: AccessScope | undefined,
  availableFunctionKeys: AvailableFunctionKeysResult | undefined,
): AccessDecision => {
  // accessScopeの設定漏れは未分類のルートとして開かせない
  if (scope === undefined) return 'deny';
  if (scope === 'public' || scope === 'authenticated') return 'allow';
  if (availableFunctionKeys === undefined) return 'pending';
  if (availableFunctionKeys.kind === 'error') return 'error';
  return availableFunctionKeys.keys.includes(scope) ? 'allow' : 'deny';
};
